import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SideNavigation, { SideNavigationProps } from '@amzn/awsui-components-console/side-navigation';
import { useRegion } from '../../shared/contexts/RegionContext';
import { useFederate } from '../../shared/contexts/FederateContext';
import { isAdminUser, nonAdminHome } from '../../utils/roleUtils';
import './SideNavigation.scss';

const PortalSideNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentRegion } = useRegion();
  const { userRoles } = useFederate();
  const isAdmin = isAdminUser(userRoles);

  // The Content Connection pages are admin-only (mirrors the AdminGate route guard).
  const items: SideNavigationProps.Item[] = [
    ...(isAdmin
      ? ([
          { type: 'link', text: 'Overview', href: '/overview' },
          { type: 'link', text: 'Collections', href: '/collections' },
          { type: 'link', text: 'Applications', href: '/applications' },
          { type: 'divider' },
        ] as SideNavigationProps.Item[])
      : []),
    {
      type: 'section',
      text: 'Tools',
      items: [{ type: 'link', text: 'HTML Editor', href: '/html-editor' }],
    },
  ];

  // Knowledge Engine is GLOBAL-only; surface it only when the Portal is in the global
  // region (mirrors the KnowledgeEngineGate route guard).
  if (currentRegion === 'global') {
    items.push({
      type: 'section',
      text: 'Knowledge Engine',
      items: [{ type: 'link', text: 'Knowledge Management', href: '/knowledge-engine' }],
    });
    items.unshift({ type: 'link', text: 'Media Processing', href: '/' });
  }

  return (
    <SideNavigation
      activeHref={location.pathname}
      header={{
        href: isAdmin ? '/overview' : nonAdminHome(currentRegion),
        text: 'GCR Content Portal',
      }}
      onFollow={(event) => {
        event.preventDefault();
        navigate(event.detail.href);
      }}
      items={items}
    />
  );
};

export default PortalSideNavigation;
